const type = 'SET_TIMELINE_EVENTS_TO_PRE_PAID_ERROR';

const setTimelineEventsToPrePaidError = (data = {}) => ({
  data,
  type,
});

export default setTimelineEventsToPrePaidError;
